var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 355.01843 418.49596",
    width: 355.01843,
    height: 418.49597,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs87"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(-674.04579,-34.042309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 737.18,34.709 c 4.109,-1.067 9.661,-1.312 12.227,2.826 23.91,36.266 34.746,47.938 23.46,54.361 -3.115,0.678 -6.575,0.923 -9.618,-0.101 -4.174,-3.752 -3.151,-3.714 -29.358,-43.373 -3.156,-4.427 -1.671,-11.262 3.289,-13.713 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 680.123,67.945 c 7.484,-1.491 4.923,-1.957 66.112,34.332 10.507,4.871 3.609,23.967 -9.819,16.222 -61.424,-35.258 -59.278,-34.313 -61.671,-37.966 -1.543,-4.96 0.749,-10.281 5.378,-12.588 z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 864.603,87.123 c 9.387,3.605 16.971,10.324 25.291,15.746 12.618,-8.675 19.456,-16.265 46.185,-21.989 63.318,-2.761 120.086,36.153 79.104,144.913 -0.807,16.251 0.159,32.616 -0.894,48.896 -1.341,7.152 -2.062,14.405 -2.538,21.672 -14.644,98.214 -65.611,155.97 -85.722,155.093 -38.345,-0.68 -10.96,-31.313 -12.256,-83.084 0.505,-20.273 -3.59,-41.138 -14.477,-58.484 -18.533,-26.328 -48.338,44.652 -25.955,114.748 2.466,8.089 1.557,18.312 -5.955,23.46 -24.887,22.213 -65.979,-44.371 -79.753,-77.518 C 761.707,308.563 765.455,244.474 764.836,226.066 713.687,100.39 812.004,63.574 864.603,87.123 Z",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 674.11,137.215 c 8.066,-5.92 5.768,-4.155 26.286,-2.942 23.203,4.529 35.166,-4.39 42.638,8.709 2.437,6.763 -4.83,14.044 -11.665,12.401 -51.178,-6.056 -46.841,1.162 -57.288,-7.181 -0.057,-3.676 -0.043,-7.339 0.029,-10.987 z",
    id: "path16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShine);
export default __webpack_public_path__ + "static/media/shine.3d69fcb55e6f18414ca539f034618eb0.svg";
export { ForwardRef as ReactComponent };